<template>
  <div>
    <div class="v-table__overflow">
      <table class="v-datatable table">
        <thead>
        <tr>
          <th v-for="(h, i) in headers" :key="i" class="text-xs-left">{{ h.text }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <slot :item="item" :index="index"/>
        </tr>
        </tbody>
        <tfoot>
        </tfoot>
      </table>
    </div>
    <div class="v-datatable table">
      <div class="v-datatable__actions">
        <div class="v-datatable__actions__select">
          Rows per page:
          <v-select :class="selectClasses" :items="rowsPerPageItems"
                    :value="rowsPerPage"
                    @input="updateRowsPerPage"/>
        </div>
        <div class="v-datatable__actions__range-controls">
          <div class="v-datatable__actions__pagination">{{ lower }}-{{ upper }}</div>
          <v-btn icon small :disabled="!hasLastPage" @click="goToLastPage">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon small :disabled="!hasNextPage" @click="goToNextPage">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      headers: Array,
      items: Array,
      pagination: {
        type: Object,
        default: () => ({})
      },
      rowsPerPageItems: {
        type: Array,
        default: () => [
          5,
          10,
          25,
          { text: 'All', value: -1 }
        ]
      }
    },
    data() {
      return {
        selectClasses: [
          'input-group--dirty',
          'input-group--hide-details',
          'input-group--auto'
        ]
      };
    },
    computed: {
      rowsPerPage() {
        return this.pagination.rowsPerPage ? this.pagination.rowsPerPage : 5;
      },
      exclusiveStartKeys() {
        return this.pagination.exclusiveStartKeys || [];
      },
      lower() {
        return this.rowsPerPage > 0 ? this.rowsPerPage * this.exclusiveStartKeys.length + 1 : 1;
      },
      upper() {
        return this.lower + this.items.length - 1;
      },
      hasLastPage() {
        return this.exclusiveStartKeys.length > 0;
      },
      hasNextPage() {
        return !!this.pagination.lastEvaluatedKey;
      }
    },
    methods: {
      updateRowsPerPage(rowsPerPage) {
        this.updatePagination({ rowsPerPage });
      },
      goToLastPage() {
        if (this.hasLastPage) {
          const exclusiveStartKeys = this.exclusiveStartKeys.slice();
          exclusiveStartKeys.pop();
          this.updatePagination({ exclusiveStartKeys });
        }
      },
      goToNextPage() {
        if (this.hasNextPage) {
          const exclusiveStartKeys = this.exclusiveStartKeys.slice();
          exclusiveStartKeys.push(this.pagination.lastEvaluatedKey);
          this.updatePagination({ exclusiveStartKeys });
        }
      },
      updatePagination(changed) {
        this.$emit('update:pagination', {
          ...this.pagination,
          ...changed
        });
      }
    }
  };
</script>

<style scoped>

</style>
